import { AdyenPartnerConfiguredPaymentMethodView } from "../Settings";
import VisaLogo from "../../Assets/Finance/VisaLogo.svg";
import MasterCardLogo from "../../Assets/Finance/MasterCardLogo.svg";
import AmexLogo from "../../Assets/Finance/AmexLogo.svg";
import ACHLogo from "../../Assets/Finance/ACHLogo.svg";
import BacsLogo from "../../Assets/Finance/BacsLogo.svg";
import {
  AdyenPaymentMethodType,
  AdyenStoredPaymentMethod,
  AllowedPaymentMethod
} from "../Transaction";

export enum Currency {
  USD = "USD",
  GBP = "GBP",
  CAD = "CAD",
  USDDeprecated = "usd",
  EuroDeprecated = "eur"
}

function isAllowedPaymentMethod(
  method: AllowedPaymentMethod | AdyenStoredPaymentMethod | AdyenPartnerConfiguredPaymentMethodView
): method is AllowedPaymentMethod {
  return (method as AllowedPaymentMethod).type !== undefined;
}

function isAdyenStoredPaymentMethod(
  method: AllowedPaymentMethod | AdyenStoredPaymentMethod | AdyenPartnerConfiguredPaymentMethodView
): method is AdyenStoredPaymentMethod {
  return (method as AdyenStoredPaymentMethod).payment_method_type !== undefined;
}

export class PaymentMethodDisplayAttributes {
  key: string;
  type: AdyenPaymentMethodType;
  displayName: string = "";
  logoSrc: string = "";
  detailsDisplayLine1: string = "";
  detailsDisplayLine2: string = "";
  primary: boolean = false;

  constructor(
    method:
      | AllowedPaymentMethod
      | AdyenStoredPaymentMethod
      | AdyenPartnerConfiguredPaymentMethodView
  ) {
    this.type = isAllowedPaymentMethod(method)
      ? method.type
      : isAdyenStoredPaymentMethod(method)
        ? method.payment_method_type
        : method.type;
    this.primary = isAllowedPaymentMethod(method)
      ? false
      : isAdyenStoredPaymentMethod(method)
        ? method.primary
        : false;
    this.setDisplayAttributes(method);
    this.key = isAdyenStoredPaymentMethod(method) ? method.id.toString() : method.type;
  }

  setDisplayAttributes(
    method:
      | AllowedPaymentMethod
      | AdyenStoredPaymentMethod
      | AdyenPartnerConfiguredPaymentMethodView
  ) {
    const cardDetails = isAllowedPaymentMethod(method)
      ? ""
      : isAdyenStoredPaymentMethod(method)
        ? ` ending in ${method.metadata?.cardSummary}`
        : "";
    const expiryDate = isAllowedPaymentMethod(method)
      ? ""
      : isAdyenStoredPaymentMethod(method)
        ? `Expires ${method.metadata?.expiryDate}`
        : "";
    const accountDetails = isAllowedPaymentMethod(method)
      ? ""
      : isAdyenStoredPaymentMethod(method) && method.metadata?.bankAccountNumber
        ? `Account ending in ${method.metadata?.bankAccountNumber?.slice(-4)}`
        : "Account";
    const reference = isAllowedPaymentMethod(method)
      ? ""
      : isAdyenStoredPaymentMethod(method) && method.metadata?.mandateId
        ? `Reference: ${method.metadata?.mandateId}`
        : "";

    const displayAttributes = {
      [AdyenPaymentMethodType.Visa]: ["VISA", VisaLogo, `VISA${cardDetails}`, expiryDate],
      [AdyenPaymentMethodType.Mastercard]: [
        "Mastercard",
        MasterCardLogo,
        `Mastercard${cardDetails}`,
        expiryDate
      ],
      [AdyenPaymentMethodType.Amex]: [
        "American Express",
        AmexLogo,
        `American Express${cardDetails}`,
        expiryDate
      ],
      [AdyenPaymentMethodType.Maestro]: [
        "Maestro",
        MasterCardLogo,
        `Maestro${cardDetails}`,
        expiryDate
      ],
      [AdyenPaymentMethodType.Ach]: [
        "ACH Transfer",
        ACHLogo,
        `ACH Transfer ${accountDetails}`,
        reference
      ],
      [AdyenPaymentMethodType.Bacs]: [
        "Direct Debit",
        BacsLogo,
        `Direct Debit Transfer ${accountDetails}`,
        reference
      ]
    };

    [this.displayName, this.logoSrc, this.detailsDisplayLine1, this.detailsDisplayLine2] =
      displayAttributes[this.type] || [];
  }
}
